<template>
  <pu-search-link
    v-if="ifPriceRange && useLink"
    :search-filters="getModifiedSearchFilters({ priceRange: {} })"
    category="search"
  >
    <i18n-t
      v-if="minPrice && maxPrice"
      keypath="{minPrice} - {maxPrice}"
      class="price-range"
    >
      <template #minPrice>
        <pu-price-rounded v-if="minPrice" :price="minPrice" />
      </template>
      <template #maxPrice>
        <pu-price-rounded v-if="maxPrice" :price="maxPrice" />
      </template>
    </i18n-t>
    <i18n-t v-else-if="maxPrice" keypath="Max: {maxPrice}" class="price-range">
      <template #maxPrice>
        <pu-price-rounded v-if="maxPrice" :price="maxPrice" />
      </template>
    </i18n-t>
    <i18n-t v-else-if="minPrice" keypath="Min: {minPrice}" class="price-range">
      <template #minPrice>
        <pu-price-rounded v-if="minPrice" :price="minPrice" />
      </template>
    </i18n-t>
    <img
      src="@/assets/images/close-x.svg"
      class="icon"
      width="18"
      height="18"
      alt=""
    />
  </pu-search-link>
  <span v-else-if="ifPriceRange" class="search-summary-detail-price">
    <i18n-t
      v-if="minPrice && maxPrice"
      keypath="{minPrice} - {maxPrice}"
      class="price-range"
    >
      <template #minPrice>
        <pu-price-rounded :price="minPrice" />
      </template>
      <template #maxPrice>
        <pu-price-rounded :price="maxPrice" />
      </template>
    </i18n-t>
    <i18n-t v-else-if="maxPrice" keypath="Max: {maxPrice}" class="price-range">
      <template #maxPrice>
        <pu-price-rounded v-if="maxPrice" :price="maxPrice" />
      </template>
    </i18n-t>
    <i18n-t v-else-if="minPrice" keypath="Min: {minPrice}" class="price-range">
      <template #minPrice>
        <pu-price-rounded v-if="minPrice" :price="minPrice" />
      </template>
    </i18n-t>
    <img
      src="@/assets/images/close-x.svg"
      class="icon"
      width="18"
      height="18"
      alt=""
      @click="$emit('remove')"
    />
  </span>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { SearchFilters } from '../../../apps/search/schemas'

@Component
class SearchSummaryBarDetailsPriceRange extends Vue {
  @Prop()
  searchFilters: SearchFilters

  @Prop({ default: true })
  useLink: boolean

  getModifiedSearchFilters(filters: Partial<SearchFilters>) {
    return { ...this.searchFilters, ...filters }
  }

  get ifPriceRange() {
    return this.searchFilters.priceRange
  }

  get minPrice() {
    const price = this.searchFilters?.priceRange?.min

    if (price) {
      return {
        amount: price * 100,
        currency: 'GBP',
      }
    } else {
      return undefined
    }
  }

  get maxPrice() {
    const price = this.searchFilters?.priceRange?.max

    if (price) {
      return {
        amount: price * 100,
        currency: 'GBP',
      }
    } else {
      return undefined
    }
  }

  get hasDates(): boolean {
    const dates = this.searchFilters.dates
    if (!dates || (!dates.arrive && !dates.depart)) {
      return false
    }
    return true
  }
}

export default toNative(SearchSummaryBarDetailsPriceRange)
</script>
<style scoped>
.price-range {
  word-spacing: -0.125em;
}
</style>
